import { render, staticRenderFns } from "./FormSubmit.vue?vue&type=template&id=414ef1e7"
import script from "./FormSubmit.vue?vue&type=script&lang=ts"
export * from "./FormSubmit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports